import { importRemote } from '@module-federation/utilities';
import React from 'react';
import { MappedComponentProperties, MapTo } from '@adobe/aem-react-editable-components';
import { Model } from '@adobe/aem-spa-page-model-manager';
import { Marker } from '../../../assembler-server/types/Marker';
import { getId } from '../utils';

export const loadMfe = async (marker: Marker): Promise<React.FC<object>> => {
  const alias = getId(marker);
  let url = marker.markerUrl;
  if (marker.version) {
    url = `${marker.markerUrl}/${marker.version}/client`;
  }
  return importRemote<{ default: React.FC<object> }>({
    url,
    scope: marker.markerScope,
    module: marker.markerModule,
    bustRemoteEntryCache: true
  })
    .then((m) => m.default)
    .catch((e) => {
      console.error(`Error loading remote ${alias}: ${(e as Error).message}`);
      // eslint-disable-next-line react/display-name
      return () => <div />;
    });
};

export const registerMfeForRender = (marker: Marker, Component: React.FC<object>) => {
  const alias = getId(marker);
  const type = `${alias}${marker.markerModule.substring(1)}`;
  MapTo<MappedComponentProperties & { model: Model }>(type)((props) => <Component {...props.model} />);
};
